import React from 'react';

/**
 * Real logo files (user-provided) for the main marketplaces.
 * Fallback stylised SVG wordmarks used for the rest.
 */

const REAL_LOGOS = {
  amazon: '/logos/amazon.png',
  flipkart: '/logos/flipkart.png',
  meesho: '/logos/meesho.png',
  myntra: '/logos/myntra.png',
  ebay: '/logos/ebay.png',
};

const EtsyLogo = () => (
  <svg width="100%" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 160 60" xmlns="http://www.w3.org/2000/svg">
    <text x="0" y="45" fontFamily="Georgia, serif" fontSize="44" fontWeight="700" fill="#F16521" fontStyle="italic">Etsy</text>
  </svg>
);

const JioMartLogo = () => (
  <svg width="100%" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 180 60" xmlns="http://www.w3.org/2000/svg">
    <text x="0" y="42" fontFamily="Arial, Helvetica, sans-serif" fontSize="32" fontWeight="900" fill="#008ECC">Jio</text>
    <text x="52" y="42" fontFamily="Arial, Helvetica, sans-serif" fontSize="32" fontWeight="900" fill="#F58220">Mart</text>
  </svg>
);

const ShopcluesLogo = () => (
  <svg width="100%" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 200 60" xmlns="http://www.w3.org/2000/svg">
    <text x="0" y="42" fontFamily="Arial, Helvetica, sans-serif" fontSize="26" fontWeight="800" fill="#8CC63F">shop</text>
    <text x="66" y="42" fontFamily="Arial, Helvetica, sans-serif" fontSize="26" fontWeight="800" fill="#F58220">clues</text>
  </svg>
);

const InstagramLogo = () => (
  <svg width="100%" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 180 60" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="igGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#F58529" />
        <stop offset="50%" stopColor="#DD2A7B" />
        <stop offset="100%" stopColor="#8134AF" />
      </linearGradient>
    </defs>
    <rect x="4" y="10" width="40" height="40" rx="10" fill="url(#igGrad)" />
    <rect x="12" y="18" width="24" height="24" rx="7" fill="none" stroke="#fff" strokeWidth="2.5" />
    <circle cx="24" cy="30" r="5" fill="none" stroke="#fff" strokeWidth="2.5" />
    <circle cx="37" cy="19" r="1.8" fill="#fff" />
    <text x="52" y="38" fontFamily="Arial, Helvetica, sans-serif" fontSize="20" fontWeight="700" fill="#262626">Instagram</text>
  </svg>
);

const FacebookLogo = () => (
  <svg width="100%" height="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 180 60" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="30" r="20" fill="#1877F2" />
    <path d="M27 20 L27 25 L31 25 L30 30 L27 30 L27 45 L22 45 L22 30 L19 30 L19 25 L22 25 L22 22 Q22 17 27 17 Q29 17 31 18 L30 22 Q29 21.5 28 21.5 Q27 21.5 27 22.5 Z" fill="#fff" />
    <text x="52" y="38" fontFamily="Arial, Helvetica, sans-serif" fontSize="20" fontWeight="700" fill="#1877F2">Facebook</text>
  </svg>
);

const SVG_LOGOS = {
  etsy: EtsyLogo,
  jiomart: JioMartLogo,
  shopclues: ShopcluesLogo,
  instagram: InstagramLogo,
  facebook: FacebookLogo,
};

export default function BrandLogo({ slug, className = 'h-10' }) {
  // 1) Real logo image if we have it
  if (REAL_LOGOS[slug]) {
    return (
      <div className={className} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
        <img
          src={REAL_LOGOS[slug]}
          alt={slug}
          style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
        />
      </div>
    );
  }

  // 2) Fallback stylised SVG wordmark
  const Comp = SVG_LOGOS[slug];
  if (!Comp) return null;
  return (
    <div className={className} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
      <div style={{ width: '100%', height: '100%', maxHeight: '100%' }}>
        <Comp />
      </div>
    </div>
  );
}
